import {
  useMutation,
  type MutationHookOptions,
  type MutationTuple,
  type TypedDocumentNode,
} from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateDeviceTagsDocument } from './update.generated';

const useUpdate = <T, U>(
  document: TypedDocumentNode<T, U>,
  options: MutationHookOptions<T, U>,
): MutationTuple<T, U> => {
  const { t } = useTranslation();
  return useMutation(document, {
    ...useNotifications(document, {
      failure: t('api.device_tags.update_error'),
      success: t('api.device_tags.update_success'),
    }),
    ...options,
  });
};

export const useUpdateDeviceTags = (options: ApiOptions<typeof UpdateDeviceTagsDocument> = {}) =>
  useUpdate(UpdateDeviceTagsDocument, options);
